.subeventHeaderWrapper {
  background-color: var(--ogm-title-bg-color-1);
  width: 100%;
}

.subeventHeaderInnerWrapper {
  margin: auto;
  max-width: var(--ogm-max-width);
  padding: 12px 16px;
  color: var(--ogm-title-color-1);
  font-family: var(--ogm-font-family-1);

  @media (min-width: 1024px) {
    padding: 16px;
  }
}

.breadcrumbIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 9px;
  height: 9px;
}

.subeventEventLinkWrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  padding: unset;

  @media (min-width: 768px) {
    padding: 15px 0 0;
  }

  @media (min-width: 1024px) {
    padding: 15px 0 0;
  }

  &:hover {
    cursor: pointer;
  }
}

a.subeventEventLink {
  position: relative;
  color: inherit;
  text-decoration: none;
  font-size: 15px;
  font-family: var(--ogm-font-family-2);

  @media (min-width: 768px) {
    font-size: 15px;
  }
}

.subeventHeaderContentContainer {
  margin-top: 8px;

  @media (min-width: 768px) {
    margin: 20px 0 15px;
  }

  @media (min-width: 1024px) {
    position: sticky;
    top: 55px;
    right: 0;
    left: 0;
    z-index: var(--cxy-z-index-above-ad);
  }
}

.subeventTitle {
  font-size: 26px;
  font-family: var(--ogm-font-family-1);
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.subeventTitleMobileDropdown {
  font-size: 22px;
  font-family: var(--ogm-font-family-1);
}

.subeventTitleMobile {
  position: relative;
  padding: 0 20px 0 0;
  font-size: 22px;
  font-family: inherit;
  cursor: pointer;

  &[aria-expanded='true'] span svg {
    transform: rotate(180deg);
  }

  @media (min-width: 768px) {
    display: flex;
    gap: 8px;
  }
}

.dropdownButtonWrapper {
  display: inline-flex;
  align-items: center;
  font-family: var(--ogm-font-family-1);
  gap: 4px;
}

.dropdownIcon {
  height: 15px;
  width: 15px;
  transform: rotate(270deg);

  &[aria-expanded='true'] {
    transform: rotate(180deg);
  }
}

.subeventMenuWrapper {
  box-shadow: none;

  @media (min-width: 600px) {
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  }
}

.relatedSubeventContainer {
  display: grid;
  grid-template-columns: 85px 1fr;
  grid-column-gap: 15px;
}

.relatedSubeventDatetime {
  min-width: 55px;
  font-family: var(--ogm-font-family-2);
  font-size: 11px;
  line-height: 19px;
  font-weight: 400;
  color: var(--oc-text-subtext);
}

.relatedSubeventNameContainer {
  display: grid;
  grid-template-columns: auto min-content auto;
  grid-column-gap: 5px;
}

.relatedSubeventName {
  font-family: var(--ogm-font-family-2);
  font-size: 14px;
  line-height: 19px;
  font-weight: 500;
  color: var(--oc-text-body);

  &:hover {
    text-decoration: underline;
  }
}

.subeventHeaderTextWrapper {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  z-index: var(--cxy-z-index-internal-mid);
  margin-bottom: 8px;

  h1 {
    color: var(--ogm-title-color-1);
    font-family: var(--ogm-font-family-1);
  }

  button {
    white-space: nowrap;
    font-family: var(--ogm-font-family-2);
  }

  #change-match-dropdown {
    inset: 0px auto auto 0px;
    max-height: 400px;
    overflow-y: scroll;
  }
}

.subeventDatetime {
  display: flex;
  align-items: center;
  font-family: var(--ogm-font-family-2);
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  white-space: nowrap;

  @media (min-width: 1024px) {
    font-size: 14px;
  }
}

.subeventDatetimeWrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (min-width: 768px) {
    margin: 0 0 0 auto;
  }
}

.offersPresentIcon {
  width: 16px;
  height: 15px;
  position: relative;
  top: 3px;
}

.matchStatsNewIcon {
  display: flex;

  & span {
    position: relative;
    margin: 0 4px;
  }
}

.inPlayIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 14px;
  padding: 0 6px;
  background-color: var(--oc-secondary-red);
  border-radius: 3px;
  font-family: var(--oc-font-family);
  font-size: 10px;
  font-weight: 800;
  color: var(--oc-text-white);
  text-transform: uppercase;
}

.menuDivider {
  height: 11px;
  width: 100%;
  border: 1px solid var(--oc-line-secondary);
  background-color: var(--oc-bg-grey);

  @media (min-width: 600px) {
    display: none;
  }
}

.liveStatsHeaderFallback {
  height: 102px;

  @media (min-width: 768px) {
    height: 202px;
  }
}

.desktopOnly {
  display: none;

  @media (min-width: 768px) {
    display: block;
  }
}

.mobileOnly {
  display: block;

  @media (min-width: 768px) {
    display: none;
  }
}
